function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 251 251",
    width: 85,
    height: 85,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00000",
      stroke: "#f00000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M183.9 154.8c0-2.3-1.9-4.2-4.2-4.2h-25.1c-2.3 0-4.2 1.9-4.2 4.2s1.9 4.2 4.2 4.2h25.1c2.3-.1 4.2-1.9 4.2-4.2zM167.2 46.1V25.2c.1-2.3-1.7-4.3-4-4.4s-4.3 1.7-4.4 4V46.1c0 11.5 9.4 20.9 20.9 20.9h37.6v79.4c.1 2.3 2.1 4.1 4.4 4 2.1-.1 3.9-1.8 4-4V62.8c0-2.3-1.9-4.2-4.2-4.2h-41.8c-6.9 0-12.5-5.6-12.5-12.5zM179.7 100.4h-33.4c-2.3-.1-4.2 1.8-4.3 4.1-.1 2.2 1.5 4 3.7 4.3h34c2.3.1 4.3-1.6 4.4-3.9.1-2.3-1.6-4.3-3.9-4.4-.1-.1-.3-.1-.5-.1zM133.7 104.6c0-2.3-1.9-4.2-4.1-4.2h-25.1c-2.3-.1-4.3 1.6-4.4 3.9s1.6 4.3 3.9 4.4h25.6c2.3.1 4.1-1.8 4.1-4.1zM104.5 125.5c-2.3-.2-4.3 1.6-4.5 3.9-.2 2.3 1.6 4.3 3.9 4.5h8.9c2.3.2 4.3-1.6 4.4-3.9.2-2.3-1.6-4.3-3.9-4.4h-.5l-8.3-.1zM104.5 83.7h41.8c2.3-.1 4.1-2.1 4-4.4-.1-2.2-1.8-3.9-4-4h-41.8c-2.3.1-4.1 2.1-4 4.4.1 2.2 1.8 3.9 4 4zM129.6 133.8h41.8c2.3-.1 4.1-2.1 4-4.4-.1-2.1-1.8-3.9-4-4h-41.8c-2.3.1-4.1 2.1-4 4.4.1 2.2 1.8 3.9 4 4zM154.6 175.6c-2.3-.3-4.4 1.4-4.7 3.7s1.4 4.4 3.7 4.7h9.3c2.3.1 4.3-1.6 4.4-3.9.1-2.3-1.6-4.3-3.9-4.4h-8.8v-.1zM137.9 150.6h-33.4c-2.3 0-4.2 1.9-4.2 4.2s1.9 4.2 4.2 4.2h33.4c2.3 0 4.2-1.9 4.2-4.2 0-2.4-1.9-4.2-4.2-4.2zM137.9 175.6h-33.4c-2.3-.1-4.2 1.8-4.3 4.1-.1 2.2 1.5 4 3.7 4.3h34c2.3-.1 4.1-2.1 4-4.4-.1-2.1-1.9-3.8-4-4zM237.4 172.3l-8.4-8.4c-6-6.3-15.9-6.5-22.2-.5l-.1.1-.4.4-54.7 54.8c-.8.8-1.2 1.8-1.2 2.9v25.1c0 2.3 1.9 4.2 4.2 4.2h25.1c1.1 0 2.2-.4 2.9-1.2l54.8-54.8c6.3-5.5 7-15 1.5-21.4l-.1-.1c-.3-.4-.8-.8-1.4-1.1zm-36.4 8.9l6.6 6.6-36.3 36.3-6.6-6.6 36.3-36.3zm-42.2 61.4v-19.2l19.2 19.2h-19.2zm25.1-6l-6.6-6.6 36.3-36.3 6.6 6.6-36.3 36.3zm47.6-47.6l-5.4 5.4-19.2-19.1 5.4-5.4c2.6-3 7.1-3.3 10.1-.8.3.2.5.5.8.8l8.4 8.4c3 2.5 3.4 6.9 1 9.9-.4.2-.8.5-1.1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00000",
      stroke: "#f00000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M137.9 242.5H29.3c-6.9 0-12.6-5.6-12.6-12.6V21c0-6.9 5.6-12.6 12.5-12.6h132.1L201.9 49c1.3 1.9 3.9 2.4 5.8 1.2 1.9-1.3 2.4-3.9 1.2-5.8 0-.1-.1-.1-.1-.2-.3-.4-.6-.7-1-1L165.9 1.3c-.8-.8-1.9-1.2-3-1.2H29.2C17.7.1 8.4 9.5 8.3 21v209c0 11.5 9.4 20.9 20.9 20.9h108.7c2.3.1 4.3-1.6 4.4-3.9s-1.6-4.3-3.9-4.4l-.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00000",
      stroke: "#f00000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M137.9 200.7h-33.4c-2.3.1-4.1 2.1-4 4.4.1 2.2 1.8 3.9 4 4h33.4c2.3-.1 4.1-2.1 4-4.4-.1-2.2-1.8-3.9-4-4zM83.6 79.5c0-2.3-1.9-4.2-4.2-4.2h-25c-2.3 0-4.2 1.9-4.2 4.2v25.1c0 2.3 1.9 4.2 4.2 4.2h25c2.3 0 4.2-1.9 4.2-4.2V79.5zm-8.4 20.9H58.5V83.7h16.7v16.7zM54.3 209.1h25c2.3 0 4.2-1.9 4.2-4.2v-25.1c0-2.3-1.9-4.2-4.2-4.2h-25c-2.3 0-4.2 1.9-4.2 4.2v25.1c.1 2.3 1.9 4.2 4.2 4.2zm4.2-25.1h16.7v16.7H58.5V184zM59.7 157.7c.8.8 1.9 1.2 3 1.2h.4c1.2-.1 2.3-.8 3-1.9l16.8-25c1.3-1.9.8-4.5-1.2-5.8-1.8-1.2-4.2-.8-5.5.8l-.2.4-14 20.8-4.8-4.8c-1.8-1.5-4.4-1.3-5.9.4-1.4 1.6-1.4 3.9 0 5.5l8.4 8.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.a642c0e4dfa1592c9b658c4117e8c531.svg";
export { ForwardRef as ReactComponent };